import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    // loadComponent: () => import('./components/risk/risk').then(m => m.RiskComponent)
    loadComponent: () => import('./components/home/home').then(m => m.HomeComponent)
  },
  {
    path: 'about',
    loadComponent: () => import('./components/about/about').then(m => m.AboutComponent)
  },
  {
    path: 'risk',
    loadComponent: () => import('./components/risk/risk').then(m => m.RiskComponent)
  },
  {
    path: 'company-summary',
    loadComponent: () => import('./components/company-summary/company-summary').then(m => m.CompanySummaryComponent)
  },
  {
    path: 'similar-companies',
    loadComponent: () => import('./components/similar-companies/similar-companies').then(m => m.SimilarCompaniesComponent)
  },
  {
    path: 'eda',
    loadComponent: () => import('./components/eda/eda').then(m => m.EdaComponent)
  },
  {
    path: 'simulation',
    loadComponent: () => import('./components/simulation/simulation').then(m => m.SimulationComponent)
  },
  {
    path: 'text-analysis',
    loadComponent: () => import('./components/text-analysis/text-analysis').then(m => m.TextAnalysisComponent)
  },
  {
    path: 'prediction',
    loadComponent: () => import('./components/prediction/prediction').then(m => m.PredictionComponent)
  },
  {
    path: 'finance',
    loadComponent: () => import('./components/finance/finance').then(m => m.FinanceComponent)
  },
  {
    path: 'future-risk',
    loadComponent: () => import('./components/future-risk/future-risk').then(m => m.FutureRiskComponent)
  },
  {
    path: 'help',
    loadComponent: () => import('./components/help/help').then(m => m.HelpComponent)
  },
  {
    path: 'stock-prediction-rl',
    loadComponent: () =>
      import('./components/stock-prediction-rl/stock-prediction-rl').then(m => m.StockPredictionRlComponent)
  }
];